import React from 'react';

import ConfirmationModal from '../../../../../components/ModalConfirmation';
import { useSteelItems } from '../contexts/SteelItemsContext';

interface SteelOrderModalsProps {
  isNoItemsModalOpen: boolean;
  onCloseNoItems: () => void;
  isValidationModalOpen: boolean;
  onCloseValidation: () => void;
}

const SteelOrderModals: React.FC<SteelOrderModalsProps> = ({
  isNoItemsModalOpen, onCloseNoItems, isValidationModalOpen, onCloseValidation,
}) => {
  const { noSavedItemsType } = useSteelItems();
  const missingItems = noSavedItemsType === 'no-items';

  return (
    <>
      {isNoItemsModalOpen && (
        <ConfirmationModal
          isOpen={isNoItemsModalOpen}
          title={missingItems ? 'Atenção: Pedido sem itens' : 'Atenção: Item não salvo'}
          message={missingItems
            ? 'É necessário que o pedido tenha pelo menos um item. Clique em adicionar novo item e adicione ao pedido.'
            : "É necessário que você adicione pelo menos um item ao pedido. Clique no botão 'Adicionar ao pedido' dentro do item."
          }
          actions={[{ label: 'Entendi', onClick: onCloseNoItems, variant: 'primary' }]}
        />
      )}

      {isValidationModalOpen && (
        <ConfirmationModal
          isOpen={isValidationModalOpen}
          title="Existem erros no formulário"
          message="Por favor, verifique os campos destacados em vermelho e corrija os erros antes de continuar."
          actions={[{ label: 'Entendi', onClick: onCloseValidation, variant: 'primary' }]}
        />
      )}
    </>
  );
};

export default SteelOrderModals;
